<div class="d-flex align-items-start mt-1 p-2 position-relative contact-card"
  [ngClass]="{'contact-card-selected': selected || pinned }">
  <span class="custom-thumbnail">
    <img [src]="channelIcon" [ngClass]="{'featured-channel': item.channel?.type === 'CLOUD_API'}" class="icon-wp"
      [matTooltip]="$safeNavigationMigration(item.channel?.name)" (error)="onImageError($event)" [matTooltipPosition]="'below'"
      [matTooltipShowDelay]="1200" />

    <small class="fst-italic text-muted">
      {{
      item.user?.name
      ? (item.user.name | truncate: 22)
      : item.department?.name
      ? item.department.name
      : item.channel?.name
      }}
    </small>

    @if(!isThumbnailLoaded) {
    <div class="custom-thumbnail-loader">
      <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
    </div>
    }

    @if(getContactImage(item.contact)) {
    <img class="rounded-circle me-2" height="46" alt="{{ item.contact.name }}" [src]="getContactImage(item.contact)"
      (error)="onContactImageError($event)" (load)="onContactImageLoad()" [hidden]="!isThumbnailLoaded" />
    }
  </span>

  <div class="w-100">
    <h5 class="mt-0 mb-0 font-14 --title-display" [ngClass]="{'is-unread': unreadCount !== 0}">
      <span class="float-end text-muted font-11">
        {{ ($safeNavigationMigration(item.lastMessage?.updatedAt)) | timezoneDate: 'DD/MM/YY HH:mm': getTimezoneCompanyCurrentUser()}}
      </span>
      <span [matTooltip]="item.contact.name + ' - ' + getMaskedPhone(item.contact.phone)" [matTooltipPosition]="'above'"
        [matTooltipShowDelay]="1200">
        {{ item.contact.name | truncate: 22 }}
      </span>
    </h5>

    <p class="mb-0 text-muted font-14 --text-display">
      <span class="float-end text-end position-relative" [ngClass]="{'custom-space-text' : unreadCount !== 0}">
        @if(hasPendingWhisper) {
        <i class="ri-chat-private-line whisper-indicator me-1" [matTooltip]="'attendance.whisper.indicator' | translate"></i>
        }
        @if(unreadCount !== 0) {
        @if(unreadCount !== -1) {
        <span class="custom-badge-counter bg-success">
          {{ unreadCount }}
        </span>
        } @else {
        <span class="custom-badge-counter --small bg-success"></span>
        }
        } @else {

        <a href="javascript:void(0);" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown"
          aria-expanded="false" (click)="$event.stopPropagation(); menuOpen = !menuOpen">
          <i class="mdi mdi-dots-horizontal"></i>
        </a>

        @if(pinned) {
        <br />
        <i class="ri-pushpin-fill mt-0" [matTooltip]="'attendance.contactCard.attendancePinned' | translate"></i>
        }

        @if(menuOpen) {
        <div class="custom-dropdown-menu" (document:click)="menuOpen = false" (click)="$event.stopPropagation()">
          <button type="button" class="dropdown-item"
            (click)="$event.stopPropagation(); markAsUnread(); menuOpen = false">
            {{ 'attendance.contactCard.markAsUnread' | translate }}
          </button>
          @if (item.status !== 'CLOSED') {
          @if (!pinned && canPinnedAttendances) {
          <button type="button" class="dropdown-item"
            (click)="$event.stopPropagation(); pinnedAttendance(); menuOpen = false">
            {{ 'attendance.contactCard.pin' | translate }}
          </button>
          } @else if (pinned) {
          <button type="button" class="dropdown-item"
            (click)="$event.stopPropagation(); unpinnedAttendance(); menuOpen = false">
            {{ 'attendance.contactCard.unpin' | translate }}
          </button>
          }
          }
        </div>

        }
        }
      </span>
      @if(item.lastMessage) {
      <span class="w-75 text-nowrap">
        @switch (item.lastMessage?.type) {
        @case ('image') { {{ 'attendance.contactCard.image' | translate }} }
        @case ('video') { {{ 'attendance.contactCard.video' | translate }} }
        @case ('audio') { {{ 'attendance.contactCard.audio' | translate }} }
        @case ('document') { {{ 'attendance.contactCard.document' | translate }} }
        @case ('sticker') { {{ 'attendance.contactCard.sticker' | translate }} }
        @case ('contacts') { {{ 'attendance.contactCard.contact' | translate }} }
        @case ('call') { {{ contentMessage }} }
        @default { {{ contentMessage | truncate: 20 }} }
        }
      </span>
      }
    </p>
  </div>
</div>